module.exports = new __parcel__URL__("chrome-icon.f1369a5e.svg").toString();